export const Services = {
   "SetAutenticationrecover": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "GET",
      "descrp": "GET info user"
   },
   "changePassword": {
      "path": "https://rrapiadmin.azurewebsites.net/",
      "method": "PUT",
      "descrp": "change the password"
   }
}